import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useOrganization } from '@clerk/clerk-react';
import { useFeatureFlagsFromClerk } from '~/hooks/useOrganizationConfig';
import { isFeatureEnabled } from '~/config/organizationConfig';

/**
 * Ensures the current org has the given feature flag enabled.
 * Redirects to '/' when org is loaded and the flag is not enabled.
 * Use in route components to restrict access by feature flag.
 * @returns allowed - true when org is loaded and the feature is enabled
 */
export const useRequireFeatureFlag = (flag: string): { allowed: boolean } => {
  const navigate = useNavigate();
  const { isLoaded: isOrgLoaded } = useOrganization();
  const featureFlags = useFeatureFlagsFromClerk();
  const allowed = isFeatureEnabled(featureFlags, flag);

  useEffect(() => {
    if (isOrgLoaded && !allowed) {
      navigate({ to: '/' });
    }
  }, [isOrgLoaded, allowed, navigate]);

  return { allowed: isOrgLoaded && allowed };
};
